// extracted by mini-css-extract-plugin
export var first = "styles-module--first--8d34c";
export var line = "styles-module--line--54238";
export var opened = "styles-module--opened--106fd";
export var second = "styles-module--second--0f601";
export var wrapper = "styles-module--wrapper--35144";